import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetEmpreendimentosDisponiveisService } from '@/features/empreendimentos/brasil/http/get-empreendimentos-disponiveis.service'
import type { TGetEmpreendimentosDisponiveisResponse } from '@/features/empreendimentos/brasil/types/empreendimento'
import { empreendimentosKeys } from '@/features/empreendimentos/shared/utils/queries'

export const useEmpreendimentosDisponiveis = (params?: { apenasFuturo: boolean; enabled: boolean }) => {
  return useQuery<TGetEmpreendimentosDisponiveisResponse, AxiosError>({
    queryKey: empreendimentosKeys.disponiveis(params?.apenasFuturo),
    enabled: params?.enabled,
    initialData: [],
    queryFn: () =>
      new GetEmpreendimentosDisponiveisService().execute(params?.apenasFuturo).then((response) => response.data),
  })
}
